import {
    ACCOUNT_ERROR,
    ACCOUNT_LOADING,
    ACCOUNT_SUCCESS,
    CART_ERROR,
    CART_ERROR_RESET,
    CART_LOADING,
    CART_RESET,
    CART_SUCCESS,
    DELETE_DOMAIN_REQUEST,
    DELETE_DOMAIN_SUCCESS,
    GET_SELECTED_PRODUCT_ERROR,
    GET_SELECTED_PRODUCT_LOADING,
    GET_SELECTED_PRODUCT_RESET,
    GET_SELECTED_PRODUCT_SUCCESS,
    SET_FADEOUT_APP,
    UPDATE_CONFIG,
    UPDATE_FINISHED,
    UPDATE_POPUP_NOTIFICATION,
    UPDATE_VIEWPORT
} from './action'


const initConfiguration = () => {
    let configuration = {}
    try {
        configuration = JSON.parse(localStorage.configurations)
    } catch (e) {
        configuration = {}
    }
    return configuration
}

const initialState = {
    fadeoutApp: false,
    configurations: initConfiguration(),
    deleteDomainNameStatus: undefined,
    deleteDomainNameData: undefined,
    getSelectedProductStatus: undefined,
    getSelectedProductData: undefined,
    getSelectedProductError: undefined,
    cartStatus: undefined,
    cartData: undefined,
    cartError: undefined,
    finished: {},
    popupNotification: {},
    viewport: undefined,
    accountStatus: undefined
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_FADEOUT_APP:
            return {
                ...state,
                fadeoutApp: action.fadeoutApp
            }
        case UPDATE_CONFIG:
            return {
                ...state,
                configurations: action.configurations
            }
        case DELETE_DOMAIN_REQUEST:
            return {
                ...state,
                deleteDomainNameStatus: 'loading',
            }
        case DELETE_DOMAIN_SUCCESS:
            return {
                ...state,
                deleteDomainNameStatus: 'success',
                deleteDomainNameData: action.deleteDomainNameData
            }
        case GET_SELECTED_PRODUCT_RESET:
            return {
                ...state,
                getSelectedProductStatus: undefined,
                getSelectedProductError: undefined,
                getSelectedProductData: undefined,
            }
        case GET_SELECTED_PRODUCT_LOADING:
            return {
                ...state,
                getSelectedProductStatus: 'loading',
                getSelectedProductData: undefined,
                getSelectedProductError: undefined
            }
        case GET_SELECTED_PRODUCT_ERROR:
            return {
                ...state,
                getSelectedProductStatus: 'error',
                getSelectedProductError: action.getSelectedProductError
            }
        case GET_SELECTED_PRODUCT_SUCCESS:
            return {
                ...state,
                getSelectedProductStatus: 'success',
                getSelectedProductData: action.getSelectedProductData
            }
        case CART_LOADING:
            return {
                ...state,
                cartStatus: 'loading'
            }
        case CART_SUCCESS:
            return {
                ...state,
                cartStatus: 'success',
                cartData: action.cartData
            }
        case CART_ERROR:
            return {
                ...state,
                cartStatus: 'error',
                cartError: action.cartError
            }
        case CART_ERROR_RESET:
            localStorage.removeItem('configurations')
            return {
                ...state,
                cartStatus: 'error',
                cartError: action.cartError,
                cartData: undefined,
                configurations: {}
            }
        case CART_RESET:
            return {
                ...state,
                cartStatus: undefined,
                cartData: undefined,
                cartError: undefined
            }
        case UPDATE_FINISHED:
            return {
                ...state,
                finished: action.finished
            }
        case UPDATE_POPUP_NOTIFICATION:
            return {
                ...state,
                popupNotification: action.popupNotification
            }
        case UPDATE_VIEWPORT:
            return {
                ...state,
                viewport: action.viewport
            }
        case ACCOUNT_SUCCESS:
            return {
                ...state,
                accountStatus: 'success',
            }
        case ACCOUNT_ERROR:
            return {
                ...state,
                accountStatus: 'error'
            }
        case ACCOUNT_LOADING:
            return {
                ...state,
                accountStatus: 'loading'
            }
        default:
            return state
    }
}
